import { Command, ICommandResult } from '@/_core/cqrs/types/commands';
import { uuid } from '@/_core/utils/uuid';
import { CommentModel } from '@/api/common/index';

export class DismissAllNotificationsOnWorkspaceCommand extends Command<ICommandResult> {
    constructor(public OnlyDirectMessages: boolean) {
        super('DismissAllNotificationsOnWorkspace');
    }
}

export class DismissAllNotificationsOfUserCommand extends Command<ICommandResult> {
    constructor(public OnlyDirectMessages: boolean) {
        super('DismissAllNotificationsOfUser');
    }
}

export class DismissNotificationOfUserCommand extends Command<ICommandResult> {
    constructor(public NotificationId: string) {
        super('DismissNotificationOfUser');
    }
}

export class CardCommentModel extends CommentModel {}
export class BoardCommentModel extends CommentModel {}

export class AddBoardCommentCommand extends Command<ICommandResult> {
    public WorkspaceId: number;
    public BoardActivity: any;
    public StoryMapSlug: string;
    public StorymapId: string;

    protected constructor(
        public CommentId: string,
        public CommentText: string,
        public RepliedToId: string,
        public MentionedIds: string[],
        public IsEverybodyMentioned: boolean,
        public CreatorUserName: string,
        public CreatorUserId: string
    ) {
        super('AddBoardComment');
    }

    public static async create(
        comment: CommentModel,
        repliedToId: string,
        mentionedIds: string[],
        storymapId: string,
        storymapSlug: string,
        workspaceId: number
    ) {
        const cmd = new AddBoardCommentCommand(
            comment.id,
            comment.commentText,
            repliedToId,
            mentionedIds,
            mentionedIds.includes('EVERYBODY'),
            initAppData.currentUser.currentUserFullName,
            initAppData.currentUser.currentUserId
        );

        cmd.StorymapId = storymapId;
        cmd.StoryMapSlug = storymapSlug;
        cmd.WorkspaceId = workspaceId;

        const activityId = await uuid.create();

        const activity = {
            Content: comment.commentText,
            Datetime: new Date().toJSON(),
            EstimationUnit: '',
            Id: activityId,
            StorymapId: storymapId,
            WorkspaceId: workspaceId,
            Type: 171,
            UserId: initAppData.currentUser.currentUserShortId,
            Username: initAppData.currentUser.currentUserFullName,
        };

        cmd.BoardActivity = activity;
        return cmd;
    }
}
